import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 96 38",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 14.709c0-5.149 0-7.723 1.002-9.69a9.193 9.193 0 0 1 4.017-4.017C6.986 0 9.56 0 14.71 0h9.193c4.505 0 6.757 0 8.478.877a8.044 8.044 0 0 1 3.515 3.515c.877 1.72.877 3.973.877 8.478v11.032c0 4.505 0 6.757-.877 8.478a8.043 8.043 0 0 1-3.515 3.515c-1.72.877-3.973.877-8.478.877H12.87c-4.505 0-6.757 0-8.478-.877A8.044 8.044 0 0 1 .877 32.38C0 30.66 0 28.407 0 23.902v-9.193Z",
      fill: "#00A85C"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.417 28V14.258H9V9h19v5.258h-6.458V28h-6.125Z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", { d: "M86.995 28h-3.562V9.28h3.562V28ZM70.72 28h-3.563V9.28h7.099c1.698 0 3.145.572 4.341 1.716 1.214 1.127 1.82 2.496 1.82 4.108 0 1.577-.606 2.93-1.82 4.056-1.213 1.127-2.677 1.69-4.393 1.69H70.72V28Zm6.058-12.896c0-.745-.26-1.37-.78-1.872-.503-.503-1.127-.754-1.873-.754H70.72v5.174h3.355c.762 0 1.404-.243 1.924-.728.52-.503.78-1.11.78-1.82ZM48.47 9.28h3.562v5.356l6.942-5.356h5.07l-5.278 4.212L64.33 28h-3.9l-4.654-12.116-3.744 3.016V28H48.47V9.28Z" }, null, -1)
  ])))
}
export default { render };